import GuiContext from "config/context/guiContext";
import { useContext, useState } from "react";
import { useMfImport } from "../context/MfImportContext";
import { useGetDatabaseStructureService } from './useGetDatabaseStructureService';
import { useUpdatePermissions } from "api/permissions/usePermissions";


const initialServerStatus = {
    response: null,
    loading: false,
    error: null,
}

export const useParseMf = () => {
    const [response, setResponse] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { setTable } = useMfImport();

    const {
        URL
    } = useContext(GuiContext);

    const parseMf = async ({ file, type }) => {

        if (!file) {
            setError('Missing required fields');
            return;
        }

        const formData = new FormData();
        formData.append("file", file);

        setLoading(true);

        try {
            const res = await fetch(`${URL}/api/plugins/${type}_parse`, {
                method: 'POST',
                credentials: 'include',
                body: formData,
            });

            const data = await res.json();
            setResponse(data);
            setTable(data?.data?.compositions[0]);
            
            if (!data?.status) {
                setError(data?.message);
            }
        } catch (err) {
            setError(err.message || 'An error occurred');
        } finally {
            setLoading(false);
        }
    };


    const resetServerStatus = () => {
        setLoading(initialServerStatus.loading);
        setResponse(initialServerStatus.response);
        setError(initialServerStatus.error);
    }

    return {
        response,
        loading,
        error,
        parseMf,
        resetServerStatus
    };
};

export const useUploadMf = () => {
    const [response, setResponse] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { getDatabaseStructure } = useGetDatabaseStructureService();
    const { updatePermissions } = useUpdatePermissions();

    const {
        selected: { selectedAccount, selectedServer },
        URL
    } = useContext(GuiContext);

    const uploadMf = async ({ type, data }) => {

        const formData = new FormData();
        formData.append("server_url", selectedServer || "");
        formData.append("database", selectedAccount || "");
        formData.append("permission", data.permission || "");
        formData.append("private_key", data.private_key || "");
        formData.append("exist", data.exist);
        formData.append('scope', data.scope);
        formData.append("compositions", JSON.stringify(data.compositions));
        formData.append("file", data.file);

        setLoading(true);

        try {
            const res = await fetch(`${URL}/api/plugins/${type}_import`, {
                method: 'POST',
                credentials: 'include',
                body: formData,
            });

            const data = await res.json();
            setResponse(data);
            getDatabaseStructure();
            updatePermissions();
            
            if (!data?.status) {
                setError(data?.message);
            }
        } catch (err) {
            setError(err.message || 'An error occurred');
        } finally {
            setLoading(false);
        }
    };


    const resetServerStatus = () => {
        setLoading(initialServerStatus.loading);
        setResponse(initialServerStatus.response);
        setError(initialServerStatus.error);
    }

    return {
        response,
        loading,
        error,
        uploadMf,
        resetServerStatus
    };
};